import * as React from 'react';
import { formatText, formatDate, formatDateString, getWeekData, parseLocalDateString, setLocale } from 'bernie-l10n';
import { LocalizationContext } from 'bernie-l10n/dist/components/l10n-provider';

function L10nPlugin() {
    return {
        name: 'bernie-plugin-l10n',
        onBrowserWrapRootElement: function (pluginContext, next) {
            var getAppData = pluginContext.getAppData, setRootElement = pluginContext.setRootElement;
            var appData = getAppData();
            var context = appData.context;
            var l10nModule = { formatText: formatText, formatDate: formatDate, formatDateString: formatDateString, getWeekData: getWeekData, parseLocalDateString: parseLocalDateString, setLocale: setLocale };
            if (context) {
                l10nModule.setLocale(context.locale);
            }
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(LocalizationContext.Provider, { value: l10nModule },
                React.createElement(RootElement, null, props.children))); }; });
            return next(pluginContext);
        },
    };
}

export { L10nPlugin as default };
//# sourceMappingURL=browser.js.map
